import React, { useState, useEffect } from 'react';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { Tooltip, Select, DatePicker, Form, Modal, Button, Icon, Row, Col, Input, Skeleton, Table, message } from 'antd';
import CustomAvatar from './../components/customAvatar';
import { getCandidates, createCandidate, findCandidatesByName } from './../API';
import { modalDiv, flexCenterRight, formItemLayout } from './../theme';
import { navigate } from "@reach/router";
import Flag from "react-country-flags";
import moment from 'moment';
import { refGenerator } from './../utils';
import { allNations } from './../utils/countries';

const { Search } = Input;
const { Option } = Select;

function Candidates({form}) {
  const { getFieldDecorator } = form;
  const nations = allNations()

  const dispatch = useDispatch();
  const session = useMappedState(state => state.session);
  const candidates = useMappedState(state => state.candidates);

  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  const [candidatesData, setCandidatesData] = useState([]);
  const [showDuplatedCandidateModal, setShowDuplatedCandidateModal] = useState(false);
  const [continueLoading, setContinueLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const response = await getCandidates(session.authToken);
      dispatch({type: "INIT_CANDIDATES", payload: response.data.candidates});
      setLoading(false);
    }
    dispatch({type: "SET_INDEX", payload: "5"});
    fetchData();
    // eslint-disable-next-line
  }, []);

  const handleCreateContinue = async e => {
    e.preventDefault();
    const formResult = await form.validateFields();
    setContinueLoading(true);

    const fn = formResult.firstname.trim();
    const ln = formResult.lastname.trim();
    const result = await createCandidate(
      session.authToken,
      {
        ...formResult,
        ...{firstname: fn, lastname: ln},
        ...{reference: refGenerator('candidate', candidates.length)}
      }
    );

    if (result.data.responseCode === 0) {
      const response = await getCandidates(session.authToken);
      dispatch({type: "INIT_CANDIDATES", payload: response.data.candidates});
      setContinueLoading(false);
      setShowDuplatedCandidateModal(false);
      setShowModal(false);
      form.resetFields();
      setCandidatesData([]);
      message.success(result.data.message);
    }
    else {
      setContinueLoading(false);
      dispatch({type: "OPEN_MSG_MODAL", payload: result.data.message});
    }
  }

  const handleCreateNewCandidate = async () => {
    const formResult = await form.validateFields();
    setCreateLoading(true);

    //check if any candidate has same firstname and lastname
    const dcandidates = await findCandidatesByName(
      session.authToken,
      formResult.firstname.trim(),
      formResult.lastname.trim()
      )

    if (dcandidates.data.responseCode === 0) {
      if (dcandidates.data.candidates.length > 0) {
        setCandidatesData(dcandidates.data.candidates);
        setCreateLoading(false);
        setShowDuplatedCandidateModal(true);
      }
      else {
        const fn = formResult.firstname.trim();
        const ln = formResult.lastname.trim();
        const result = await createCandidate(
          session.authToken,
          {
            ...formResult,
            ...{firstname: fn, lastname: ln},
            ...{reference: refGenerator('candidate', candidates.length)}
          }
        );

        if (result.data.responseCode === 0) {
          const response = await getCandidates(session.authToken);
          dispatch({type: "INIT_CANDIDATES", payload: response.data.candidates});
          setCreateLoading(false);
          setShowModal(false);
          form.resetFields();
          setCandidatesData([]);
          message.success(result.data.message);
        }
        else {
          setCreateLoading(false);
          dispatch({type: "OPEN_MSG_MODAL", payload: result.data.message});
        }
      }
    }
    else{
      setCreateLoading(false);
      dispatch({type: "OPEN_MSG_MODAL", payload: dcandidates.data.message});
    }
  }

  const columns = [
    {
      title: '',
      width: '1%',
      key: 'bothSide',
      render: (candidate) => <>
      {
        candidate.bothSide ? (
          <div>
            <Tooltip title="This candidate is contact as well" >
              <Icon type="swap" />
            </Tooltip>
          </div>
        ) : null
      }
      </>
    },
    {
      title: '',
      width: '1%',
      key: 'avatar',
      render: (candidate) =>
      <CustomAvatar
        colourCode={candidate.firstname.charAt(0).toLowerCase()}
        char={`${candidate.firstname.charAt(0).toUpperCase()}${candidate.lastname.charAt(0).toUpperCase()}`}
        charSize={12}
        src={candidate.avatar}
      />
    },
    {
      title: '',
      width: '2%',
      dataIndex: 'salutation',
      key: 'salutation',
    },
    {
      title: 'Name',
      width: '10%',
      dataIndex: 'fullname',
      sorter: (a, b) => a.fullname.localeCompare(b.fullname),
      key: 'fullname',
    },
    // {
    //   title: 'Country',
    //   width: '7%',
    //   dataIndex: 'country',
    //   sorter: (a, b) => a.reference.localeCompare(b.country),
    //   key: 'country',
    // },
    {
      title: 'Location',
      width: '7%',
      dataIndex: 'location',
      sorter: (a, b) => a.reference.localeCompare(b.location),
      key: 'location',
    },
    {
      title: 'Service',
      width: '9%',
      dataIndex: 'service',
      sorter: (a, b) => a.service.localeCompare(b.service),
      key: 'service',
    },
    {
      title: 'Position',
      width: '9%',
      dataIndex: 'position',
      sorter: (a, b) => a.position.localeCompare(b.position),
      key: 'position',
    },
    {
      title: '',
      width: '8%',
      render: (candidate) => <div style={flexCenterRight}>
        <Button disabled={
          !candidate.linkedin || candidate.linkedin === ""
        } size="small" onClick={() => {
          if (candidate.linkedin && candidate.linkedin !== "") {
            window.open(candidate.linkedin, '_blank');
          }
          else {
            dispatch({type: "OPEN_MSG_MODAL", payload: "linkedin is not available"});
          }
        }}><Icon type="linkedin" /></Button>
        &nbsp;&nbsp;&nbsp;
        <Button size="small" onClick={() => {
          navigate(`/candidates/${candidate.id}`)
        }}><Icon type="plus" /></Button>
      </div>
    }
  ];

  const countrySelection = [];
  for (let i = 0; i < nations.length; i++) {
    countrySelection.push(
      <Option key={i} value={nations[i].name} label={nations[i].name}>
        <Row>
          <Col span={4}>
            <Flag country={nations[i].code} asSquare={true} style={{width: '30px', height: '20px'}}/>
          </Col>
          <Col>
            {nations[i].name}
          </Col>
        </Row>
      </Option>
    )
  }

  const candidateSelection = [];
  for (let i = 0; i < candidatesData.length; i++) {
    candidateSelection.push(
    <Row
      key={i}
      style={{
      marginTop: '5px',
      marginBottom: '5px',
    }}>
      <Col span={2}>
        <CustomAvatar
          colourCode={candidatesData[i].firstname.charAt(0).toLowerCase()}
          char={`${candidatesData[i].firstname.charAt(0).toUpperCase()}${candidatesData[i].lastname.charAt(0).toUpperCase()}`}
          charSize={12}
          src={candidatesData[i].avatar}
        />
      </Col>
      <Col span={1}>
        {candidatesData[i].salutation ? candidatesData[i].salutation : null}
      </Col>

      <Col span={6}>
        {`${candidatesData[i].firstname} ${candidatesData[i].lastname}`}
      </Col>
      <Col span={6}>
        {
          candidatesData[i].dob ?
          moment(candidatesData[i].dob).format('YYYY-MM-DD')
          :
          null
        }
      </Col>
      <Col span={4}>
        {candidatesData[i].position ? candidatesData[i].position : null}
      </Col>
    </Row>
    );
  }

  return (
    loading ?
    <div>
      <p>Loading...</p>
      <Skeleton active />
    </div>
    :
    <React.Fragment>
    {/* this modal will show duplicated candidates */}
    <Modal
      centered={true}
      title="Duplicated Candidates Warning"
      closable={false}
      visible={showDuplatedCandidateModal}
      width={600}
      footer={[
        <Button key="cancel" onClick={() => {
          setShowDuplatedCandidateModal(false);
          setShowModal(false);
          form.resetFields();
          setCandidatesData([]);
        }}>
          <Icon type="close" />
          Cancel
        </Button>,
        <Button key="create" type="primary" onClick={handleCreateContinue}>
          {continueLoading ? <Icon type="loading" /> : <Icon type="check" />}
          Continue
        </Button>
      ]}
    >
      <div>
      <Icon type="warning" theme="twoTone" twoToneColor="red" style={{fontSize: "24px"}}/>
      &nbsp;&nbsp;
      All duplicated candidates show below
      <br/><br/>
      </div>
      {candidateSelection}
    </Modal>
    {/* this modal serve create new client */}
    <Modal
      centered={true}
      title="Create New Candidate"
      closable={false}
      visible={showModal}
      width="90%"
      footer={[
        <Button disabled={createLoading} key="cancel" onClick={() => {
          setShowModal(false);
          form.resetFields();
        }}>
          <Icon type="close" />
          Cancel
        </Button>,
        <Button key="create" type="primary" onClick={handleCreateNewCandidate}>
          {createLoading ? <Icon type="loading" /> : <Icon type="check" />}
          Create
        </Button>
      ]}
    >
      <div style={modalDiv}>
        <Form>
          <Row>
            <Col span={12}>
              <div style={{marginRight: '10px'}}>
                <Form.Item {...formItemLayout} label="Salutation">
                  {getFieldDecorator('salutation', {})(
                    <Input autoComplete="off" placeholder="Salutation" disabled={createLoading} />
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="First Name">
                  {getFieldDecorator('firstname', {
                    rules: [{ required: true, message: 'Please input firstname!' }],
                  })(
                    <Input autoComplete="off" placeholder="First Name" disabled={createLoading} />
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="Last Name">
                  {getFieldDecorator('lastname', {
                    rules: [{ required: true, message: 'Please input lastname!' }],
                  })(
                    <Input autoComplete="off" placeholder="Last Name" disabled={createLoading} />
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="Country">
                  {getFieldDecorator('country', {})(
                    <Select
                      disabled={createLoading}
                      placeholder="Country"
                      optionLabelProp="label"
                      showSearch
                    >
                    {countrySelection}
                    </Select>
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="Region">
                  {getFieldDecorator('region', {})(
                    <Input autoComplete="off" placeholder="Region" disabled={createLoading} />
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="Birthday">
                  {getFieldDecorator('dob', {})(
                    <DatePicker placeholder="Date of Birth" style={{width: "100%"}} disabled={createLoading} />
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="Email">
                  {getFieldDecorator('email', {
                    rules: [
                      {
                        type: "email",
                        message: "Please input valid email!",
                      },
                      {
                        required: true,
                        message: 'Please input email!'
                      }
                    ],
                  })(
                    <Input autoComplete="off" placeholder="Email" disabled={createLoading} />
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="Optional Email 1">
                  {getFieldDecorator('email1', {
                    rules: [
                      {
                        type: "email",
                        message: "Please input valid email!",
                      }
                    ],
                  })(
                    <Input autoComplete="off" placeholder="Optional Email 1" disabled={createLoading} />
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="Optional Email 2">
                  {getFieldDecorator('email2', {
                    rules: [
                      {
                        type: "email",
                        message: "Please input valid email!",
                      }
                    ],
                  })(
                    <Input autoComplete="off" placeholder="Optional Email 2" disabled={createLoading} />
                  )}
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div style={{marginLeft: '10px'}}>
                <Form.Item {...formItemLayout} label="Mobile">
                  {getFieldDecorator('mobile', {})(
                    <Input autoComplete="off" placeholder="Mobile" disabled={createLoading} />
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="Location">
                  {getFieldDecorator('location', {
                    rules: [{ required: true, message: 'Please input location!' }],
                  })(
                    <Input autoComplete="off" placeholder="Location" disabled={createLoading} />
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="Service">
                  {getFieldDecorator('service', {})(
                    <Input autoComplete="off" placeholder="Service" disabled={createLoading} />
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="Position">
                  {getFieldDecorator('position', {})(
                    <Input autoComplete="off" placeholder="Position" disabled={createLoading} />
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="LinkedIn">
                  {getFieldDecorator('linkedin', {})(
                    <Input autoComplete="off" placeholder="Linkedin" disabled={createLoading} />
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="Wechat">
                  {getFieldDecorator('wechat', {})(
                    <Input autoComplete="off" placeholder="Wechat" disabled={createLoading} />
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="Whats app">
                  {getFieldDecorator('whatsapp', {})(
                    <Input autoComplete="off" placeholder="Whats app" disabled={createLoading} />
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="Other Contact">
                  {getFieldDecorator('othercontact', {})(
                    <Input autoComplete="off" placeholder="Other Contact" disabled={createLoading} />
                  )}
                </Form.Item>

                <Form.Item {...formItemLayout} label="Source">
                  {getFieldDecorator('source', {})(
                    <Input autoComplete="off" placeholder="Source" disabled={createLoading} />
                  )}
                </Form.Item>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>

    <div>
      <Row>
        <Col span={12}>
          <Search
            placeholder="Search"
            onChange={e => setSearch(e.target.value)}
            style={{ width: 200 }}
          />
        </Col>
        <Col span={12}>
          <div style={flexCenterRight}>
            <Button type="primary" onClick={() => {
              setShowModal(true);
            }}><Icon type="plus-square" /> New Candidate</Button>
          </div>
        </Col>
      </Row>

      <br/>
      <Table
        columns={columns}
        dataSource={
          search === ""?
          candidates.map(i => {
          return {...i, ...{fullname: `${i.firstname} ${i.lastname}`}}
          })
          :
          candidates.map(i => {
          return {...i, ...{fullname: `${i.firstname} ${i.lastname}`}}
          }).filter( e =>
            e.fullname.toLowerCase().includes(search.toLowerCase()) ||
            e.service.toLowerCase().includes(search.toLowerCase()) ||
            e.position.toLowerCase().includes(search.toLowerCase()) ||
            e.location.toLowerCase().includes(search.toLowerCase())
          )
        }
        rowKey="id"
      />
    </div>
    </React.Fragment>
  );
}

const CandidatesForm = Form.create({ name: 'candidates' })(Candidates);

export default CandidatesForm;
